import { TableCell, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Edit, GripVertical, Trash2 } from "lucide-react";
import { PolicyType } from "../types";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

interface SortableTableRowProps {
  id: string;
  type: PolicyType;
  onEdit: (policyType: PolicyType) => void;
  onDelete: (id: string) => void;
}

export const SortableTableRow = ({ id, type, onEdit, onDelete }: SortableTableRowProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    backgroundColor: isDragging ? 'rgb(243 244 246)' : undefined,
    cursor: 'grab'
  };

  return (
    <TableRow 
      ref={setNodeRef} 
      style={style} 
      className={`${isDragging ? 'opacity-50' : ''} hover:bg-gray-50`}
    >
      <TableCell className="w-[40px]">
        <Button 
          variant="ghost" 
          size="icon" 
          className="cursor-grab hover:bg-gray-100" 
          {...attributes} 
          {...listeners}
        >
          <GripVertical className="h-4 w-4 text-gray-400" />
        </Button>
      </TableCell>
      <TableCell>{type.name}</TableCell>
      <TableCell>{type.description || '-'}</TableCell>
      <TableCell>
        <div className="flex space-x-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onEdit(type)}
          >
            <Edit className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onDelete(type.id)}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
};